import { useState } from 'react';
import PaginationSection from '../../../components/pagination/PaginationSection';
import usePaginatedTable from '../../../hooks/UsePaginatedTable';
import CheckboxSelectAlllRegistrations from './CheckboxSelectAllRegistrations';
import RegistrationCard from './RegistrationCard';

function RegistrationCardContainer({
  rowsPerPage,
  batchSelectedElements,
  setBatchSelectedElements,
  data,
  setData,
  competitionStatus,
}) {
  const [page, setPage] = useState(1);
  const { slice, range } = usePaginatedTable(data, page, rowsPerPage);

  return (
    <div className='d-flex flex-column gap-3'>
      {(competitionStatus === 'Kommande' ||
        competitionStatus === 'Pågående') && (
        <CheckboxSelectAlllRegistrations
          batchSelectedRegistrations={batchSelectedElements}
          registrations={data}
          setBatchSelectedRegistrations={setBatchSelectedElements}
          slice={slice}
          includeText={true}
          id='cb-select-all'
        />
      )}
      <div className='d-flex flex-column gap-3'>
        {slice.map((r, index) => (
          <RegistrationCard
            key={r.name + index}
            batchSelectedRegistrations={batchSelectedElements}
            registration={r}
            setBatchSelectedRegistrations={setBatchSelectedElements}
            setRegistrations={setData}
            status={competitionStatus}
          />
        ))}
      </div>
      <PaginationSection
        page={page}
        range={range}
        slice={slice}
        setPage={setPage}
      />
    </div>
  );
}

export default RegistrationCardContainer;
